<script setup lang="ts" name="OTPScreen">
  import { AuthService } from '@/service/AuthService'
  import { AltType, LoginStrategy } from '@/utils/const'
  import { useStore } from '@/utils/store'
  import { getErrorMessage } from '@/utils/utils'
  import { ArrowLeftIcon } from '@gohighlevel/ghl-icons/24/outline'
  import { UIButton, UIInputOtp, UITextMdNormal, useNotification } from '@gohighlevel/ghl-ui'
  import { useCookies } from '@vueuse/integrations/useCookies'
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
  const props = defineProps({
    email: {
      type: String,
      required: true,
    },
    contactId: {
      type: String,

      required: true,
    },
  })
  const cookies = useCookies(['token'])

  const emit = defineEmits(['backToLogin', 'onLogin'])
  const store = useStore()
  const otp = ref('0')
  const submitLoading = ref(false)
  const notification = useNotification()
  const handleSubmit = async () => {
    submitLoading.value = true
    try {
      const response = await AuthService.loginWithOtp({
        altId: store.locationId.value,
        email: props.email,
        altType: AltType.LOCATION,
        storeId: store.storeId.value,
        contactId: props.contactId,
        otp: otp.value,
        strategy: LoginStrategy.OTP,
      })
      if (!response.data?.status) {
        throw new Error(response.data.message)
      }
      const data = response.data.data || {}
      const user = {
        name: [data?.firstName, data?.lastName].filter(Boolean).join(' '),
        email: data.email,
      }
      localStorage.setItem(`user_${store.storeId.value}`, JSON.stringify(user))
      cookies.set(`token_${store.storeId.value}`, data.token, {
        path: '/',
        expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30),
      })
      store.token.value = data.token
      store.isLogin.value = false
      store.user.value = user
      emit('onLogin')
    } catch (error: unknown) {
      console.error(error)
      notification.create({
        title: 'Error',
        description: getErrorMessage(error, 'Error sending OTP, please try again later'),
        type: 'error',
        duration: 5000,
      })
    } finally {
      submitLoading.value = false
    }
  }
</script>

<template>
  <div class="max-w-96 mx-auto flex flex-col items-center">
    <h1 class="text-2xl font-semibold">{{ t('otp.checkEmail') }}</h1>
    <UITextMdNormal class="text-gray-500 text-center">{{ t('otp.verificationSent') }} {{ email }}</UITextMdNormal>

    <UIInputOtp
      class="mt-6"
      :fields="6"
      @on-complete="val => (otp = val.otp)"
      @onChange="(val: string) => (otp = val)"
      id="otp"
      placeholder="0"
    />

    <UIButton
      :disabled="otp.length < 6"
      :loading="submitLoading"
      @click="handleSubmit"
      class="w-full mt-6"
      id="otp-submit-button"
      type="primary"
    >
      {{ t('otp.submit') }}
    </UIButton>

    <UIButton class="mt-6" :linkGray="true" :text="true" id="back-to-login" @click="$emit('backToLogin')">
      <ArrowLeftIcon class="mr-2 w-5 h-5" />
      <span>{{ t('otp.backToLogin') }}</span>
    </UIButton>
  </div>
</template>
<style></style>
